import { reactive } from "vue";
import type { StoredSettings } from "./CanvasSettingsState";
import BlockLibrary from "@/blocks/library";
import { Facade } from "@/drawing";
import _ from "lodash";
import CanvasSettingsState from "./CanvasSettingsState";

type DraggerOptionState = {
  storedSettings: StoredSettings | null;
  activeBlock: { name: string } | null;
  initialize: (storedSettings: StoredSettings | null) => void;
  setActiveBlock: (name: string) => void;
  onDrawingOpen: () => void;
  importDRBlock: (name: string) => void;
};

export default reactive<DraggerOptionState>({
  storedSettings: null,
  activeBlock: null,
  initialize(storedSettings: StoredSettings | null) {
    this.storedSettings = storedSettings;
    const savedName = storedSettings?.dragger?.activeBlock?.name;
    if (savedName) {
      this.activeBlock = { name: savedName };
    }
  },
  onDrawingOpen() {
    if (this.activeBlock) {
      this.setActiveBlock(this.activeBlock.name);
    }
  },
  setActiveBlock(name) {
    if (Facade.isInitialized) {
      const isDR = !!BlockLibrary.getByName(name);
      this.activeBlock = name ? { name } : null;
      Facade.blocks.setActiveBlock(name);

      // Persist selected DR Blocks
      if (isDR) {
        this.storedSettings = _.set(
          this.storedSettings || {},
          "dragger.activeBlock.name",
          name
        );
        CanvasSettingsState.updateAndPersist();
      }
    }
  },
  importDRBlock(name) {
    const blockConfig = BlockLibrary.getByName(name);
    if(blockConfig) {
      Facade.blocks.importDRBlock(blockConfig)
    }
  }
});
